module.exports = __webpack_public_path__ + "img/W-S06.87700181.jpg";